import { User } from 'app/types'

export interface CanInteractOptions {
  user: Pick<User, 'userType'> | null
  group?: {
    allowedUserTypes: string[]
  }
}

/**
 * This is a helper function that determines if a user can post to a group.
 *
 *! Ideally we would have these access rules in the GraphQL schema, but this is
 *! a brute force way of doing it for now until we can figure out the exact
 *! access rules for each group, and how they can be configurable.
 *
 * @param options Options used for determining if a user can interact with a group
 * @returns True if the user can interact with the group, otherwise false
 */
export const canInteract = (options: CanInteractOptions): boolean => {
  // Only logged in users can interact with groups
  if (!options.user) {
    return false
  }

  // Only users who are members of the group can interact with the group
  if (!options.group) {
    return false
  }

  // Only users of the allowed user types can interact with the group
  return options.group.allowedUserTypes?.includes(options.user.userType || '')
 
}
